import { FC, useEffect, useMemo, useState } from "react"
import { Translated } from "../utils/translated"
import { Tabs, TabsProps } from "antd"
import { BugOutlined, ReloadOutlined, UserOutlined } from "@ant-design/icons"
import { FlexCol } from "../components/commons-ts/common"
import { AccountSettings } from "./Settings/AccountSettings"
import { useHistory, useLocation } from "react-router-dom"
import { useSyncronizationContext } from "../providers/syncronizationProvider"
import { UpdatesPage } from "./UpdatesPage"
import { DebugPage } from "./DebugPage"
import { CENTRAL_CONTAINER_GAP } from "../utils/utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBuilding } from "@fortawesome/free-solid-svg-icons"
import { EnterpriseSettings } from "./Settings/EnterpriseSettings"

export enum EGeneralSettingsTabKey {
  UserAccount = "user-account",
  EnterpriseAccount = "enterprise-account",
  Updates = "updates",
  Debug = "debug",
}

export const SettingsGeneral: FC = () => {
  const location = useLocation()
  const history = useHistory()
  const [selectedTabKey, setSelectedTabKey] = useState<EGeneralSettingsTabKey>(
    EGeneralSettingsTabKey.UserAccount,
  )
  const { isAdmin } = useSyncronizationContext()

  useEffect(() => {
    let parts = location.pathname.split("/")
    let arg = parts[parts.length - 1]
    if (arg === undefined) {
      return
    }
    switch (arg) {
      case EGeneralSettingsTabKey.UserAccount:
        setSelectedTabKey(EGeneralSettingsTabKey.UserAccount)
        break
      case EGeneralSettingsTabKey.EnterpriseAccount:
        setSelectedTabKey(EGeneralSettingsTabKey.EnterpriseAccount)
        break
      case EGeneralSettingsTabKey.Updates:
        setSelectedTabKey(EGeneralSettingsTabKey.Updates)
        break
      case EGeneralSettingsTabKey.Debug:
        setSelectedTabKey(EGeneralSettingsTabKey.Debug)
        break
      default:
        setSelectedTabKey(EGeneralSettingsTabKey.UserAccount)
        break
    }
  }, [location.pathname])

  const memoTabItems = useMemo(() => {
    let items: TabsProps["items"] = [
      {
        key: EGeneralSettingsTabKey.UserAccount,
        label: (
          <span
            style={{
              marginLeft: 5,
            }}
          >
            <Translated keyEn="User account" />
          </span>
        ),
        icon: <UserOutlined />,
        children: <AccountSettings />,
      },
      {
        key: EGeneralSettingsTabKey.EnterpriseAccount,
        label: (
          <span
            style={{
              marginLeft: 5,
            }}
          >
            <Translated keyEn="Enterprise account" />
          </span>
        ),
        icon: <FontAwesomeIcon icon={faBuilding} />,
        children: <EnterpriseSettings />,
      },
      {
        key: EGeneralSettingsTabKey.Updates,
        label: (
          <span
            style={{
              marginLeft: 5,
            }}
          >
            <Translated keyEn="Updates" />
          </span>
        ),
        icon: <ReloadOutlined />,
        children: <UpdatesPage />,
      },
      {
        key: EGeneralSettingsTabKey.Debug,
        label: (
          <span
            style={{
              marginLeft: 5,
            }}
          >
            <Translated keyEn="Debug" />
          </span>
        ),
        icon: <BugOutlined />,
        children: <DebugPage />,
      },
    ]
    return items
  }, [isAdmin])

  return (
    <FlexCol
      style={{
        width: "100%",
        gap: CENTRAL_CONTAINER_GAP,
      }}
    >
      <Tabs
        style={{
          width: "100%",
        }}
        destroyInactiveTabPane
        // centered
        animated
        tabBarGutter={20}
        activeKey={selectedTabKey}
        onChange={(key: string) => {
          setSelectedTabKey(key as EGeneralSettingsTabKey)
          history.push(`/settings/general/${key}`)
        }}
        size="large"
        items={memoTabItems}
      ></Tabs>
    </FlexCol>
  )
}
